import { cn } from "@/lib/utils";

// Minimal, opinionated input wrapper for calculators.
// Variants: "currency", "percent", "number", "text"
export default function Field({
    label,
    hint,
    prefix,
    suffix,
    value,
    onChange,
    type = "number",
    step = 1,
    min,
    max,
    placeholder,
    dataTestId,
    children,
    slider,
}) {
    return (
        <div className="space-y-1.5">
            <label className="block font-sans text-[11px] uppercase tracking-[0.18em] text-primary/80 font-medium">
                {label}
            </label>
            {children ? (
                children
            ) : (
                <div className="relative">
                    {prefix && (
                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-muted-foreground font-mono text-sm">
                            {prefix}
                        </span>
                    )}
                    <input
                        type={type}
                        step={step}
                        min={min}
                        max={max}
                        placeholder={placeholder}
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                        data-testid={dataTestId}
                        className={cn(
                            "w-full h-12 rounded-md bg-background border border-border",
                            "font-mono tabular text-base text-primary",
                            "focus:outline-none focus:ring-2 focus:ring-accent/40 focus:border-accent",
                            "transition-colors",
                            prefix ? "pl-8" : "pl-3",
                            suffix ? "pr-10" : "pr-3",
                        )}
                    />
                    {suffix && (
                        <span className="absolute inset-y-0 right-0 flex items-center pr-3 text-muted-foreground font-mono text-sm">
                            {suffix}
                        </span>
                    )}
                </div>
            )}
            {slider}
            {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
        </div>
    );
}
